"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$axiosRefresh = exports.$axios = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_auth_refresh_1 = __importDefault(require("axios-auth-refresh"));
const csrfHandler_1 = require("./handler/csrfHandler");
const HTTP_PRECONDITION_FAILED = 412;
exports.$axios = axios_1.default.create({
    baseURL: currentContextPath,
});
exports.$axiosRefresh = axios_1.default.create({
    baseURL: currentContextPath,
});
(0, axios_auth_refresh_1.default)(exports.$axios, csrfHandler_1.csrfHandler, {
    statusCodes: [HTTP_PRECONDITION_FAILED],
    pauseInstanceWhileRefreshing: true,
    retryInstance: exports.$axiosRefresh,
});
exports.$axios.interceptors.request.use((config) => {
    config.__retryCount = config.__retryCount || 0;
    return config;
});
exports.$axios.interceptors.response.use((response) => response, 
// eslint-disable-next-line complexity
async (error) => {
    var _a;
    const config = error.config;
    const token = (_a = error.response) === null || _a === void 0 ? void 0 : _a.headers["csrftoken"];
    token && (0, csrfHandler_1.setCSRFToken)(token);
    if (config && config.headers && token) {
        config.headers["CSRFToken"] = token;
    }
    if (config && error.response && error.response.status === HTTP_PRECONDITION_FAILED && config.__retryCount < 3) {
        config.__retryCount += 1;
        // Retry the request
        return (0, exports.$axios)(config);
    }
    return Promise.reject(error);
});
